// @core/api/endpoints/signature/prepare_signing.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PrepareSigningRequest,
  PrepareSigningResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Prepare a jurisdiction-aware signing procedure
 * Persists party questionnaires and the contract context, then returns applicable procedure versions, missing requirements and blockers.
 */
export async function PrepareSigning(
  data: PrepareSigningRequest,
  options?: RequestOptions
): Promise<PrepareSigningResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/signing/prepare`;
  const requestOptions = options;
  return client.post<PrepareSigningResponse>(requestPath, data, requestOptions);
}
